<template>
	<v-app toolbar>
		<v-navigation-drawer
			persistent v-model="drawer"
			overflow enable-resize-watcher
			class="print-no-show">
			<v-toolbar flat class="toolbar--hk">
				<img src="/static/img/logo-control-inn.png" class="mx-a" />
			</v-toolbar>
			<v-list dense class="py-0 list--hk">
				<template v-for="(item, i) in sidebar">
					<v-list-group
						:key="i"
						no-action
						v-model="item.active">
						<v-list-tile
							slot="item"
							v-if="item.resource.data.length > 0">
							<v-list-tile-action>
								<img :src="item.pathIcon" :alt="item.name" width="19" height="19" />
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>
									{{ item.name }}
								</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
						<v-list-tile
							slot="item"
							v-else
							:key="i"
							:to="item.url"
							:class="{ 'active': `/${$route.fullPath.split('/')[1]}` === item.url }">
							<v-list-tile-action>
								<img :src="item.iconUrl" :alt="item.description" width="17" height="17" />
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>
									{{ item.name }}
								</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
						<v-list-tile
							v-for="(child, i) in item.resource.data"
							:key="i"
							class="sidebar-bg"
							:to="{ name: `${child.uri}` }"
							:class="{ 'active': `/${$route.fullPath.split('/')[1]}` === child.uri }">
							<v-list-tile-action v-if="child.iconUrl">
								<img :src="child.iconUrl" :alt="child.description" width="17" height="17" />
							</v-list-tile-action>
							<v-list-tile-content>
								<v-list-tile-title>
									{{ child.name }}
								</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list-group>
				</template>
			</v-list>
		</v-navigation-drawer>
		<v-toolbar fixed class="white toolbar-header toolbar--hk print-no-show" light>
			<button type="button" @click.stop="drawer = !drawer" class="button-drawer ma-0">
				<img src="/static/img/bars.svg" alt="">
			</button>
			<button
				type="button"
				class="notifications-btn mr-3"
				id="buttonNotifications"
				@click="openNotifications">
				<p :class="{ 'animated bounceIn' : newNotification }">
					<span>{{ notificationsQuantity }}</span>
				</p>
				<img
					src="//picture-controlinn.s3.amazonaws.com/housekeeping/icon-notification.svg"
					alt=""
					height="22"
					width="21">
			</button>
			<div
				v-show="notificationsList"
				class="notifications-container"
				id="notifications">
				<v-layout row wrap align-center text-xs-left px-3>
					<v-flex xs2>
						<label>Sucursal:</label>
					</v-flex>
					<v-flex xs2>
						<label>Cliente</label>
					</v-flex>
					<v-flex xs2>
						<label>Cod. Reserva:</label>
					</v-flex>
					<v-flex xs2>
						<label>Tipo de Hab.:</label>
					</v-flex>
					<v-flex xs2>
						<label>Fec. de Reserva:</label>
					</v-flex>
				</v-layout>
				<v-layout row wrap px-3 class="notifications-list">
					<v-flex xs12>
						<v-layout row wrap class="notifications-list-height">
							<v-flex xs12
								v-for="notification in notifications"
								:key="notification.id"
								text-xs-left
								class="notifications-list-border">
								<v-layout row wrap align-center>
									<v-flex xs2>
										<p>{{ notification.hotelName }}</p>
									</v-flex>
									<v-flex xs2>
										<p>{{ notification.customer }}</p>
									</v-flex>
									<v-flex xs2>
										<p>{{ notification.code }}</p>
									</v-flex>
									<v-flex xs2>
										<p>{{ notification.roomName }}</p>
									</v-flex>
									<v-flex xs2>
										<p>{{ notification.bookingStart | parseDate }} - {{ notification.bookingEnd | parseDate }}</p>
									</v-flex>
									<v-flex xs2 text-xs-right>
										<v-btn fab dark small error
											class="notifications-actions"
											@click="deleteNotification(notification)"
										>
											<v-icon dark>close</v-icon>
										</v-btn>
										<v-btn fab dark small
											class="notifications-actions reservation"
											@click="selectData(notification)"
										>
											R
										</v-btn>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</div>
			<div class="logo">
				<img src="/static/img/icons/qp-hotels-header.svg" alt="logo-header-qp">
			</div>
			<v-layout row justify-end class="layout-nav user">
				<div class="user-name">
					<h6>{{user.fullName}}</h6>
				</div>
				<button type="button" class="user-img my-0">
					<img v-bind:src="user.url_image" alt="">
				</button>
				<v-menu offset-y class="pt-1" content-class="menu-layout">
					<v-btn icon slot="activator">
						<span class="sprite-extra settings"></span>
					</v-btn>
					<v-list>
						<v-list-tile
							v-for="(language, indexLang) in languages"
							:key="language.id"
							@click="setLanguage(indexLang)"
							:class="{ 'active' : indexLang === localLanguage }"
						>
							<v-list-tile-avatar>
								<img
									:src="language.img"
									:alt="language.name"
								/>
							</v-list-tile-avatar>
							<v-list-tile-title>{{ language.name }}</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
			</v-layout>
			<button type="button"
					class="login-button mr-0"
					v-on:click.stop="dialog = true">
				<v-icon>power_settings_new</v-icon>
			</button>
		</v-toolbar>
		<main class="print-width">
			<template>
				<div :class="{ 'billing-breadcrumb-style': $route.path === '/billing/list' }">
					<div
						class="billing-breadcrumb"
						v-if="$route.path === '/billing/list'">
						<div class="billing-resume">
							<div>
								<p class="billing-resume-title">INGRESOS</p>
								<p class="billing-resume-content">${{ bookingsAmountTotal | round }}</p>
							</div>
							<div>
								<p class="billing-resume-title">Ocupación Actual</p>
								<p class="billing-resume-content">{{ bookingsTotal }}</p>
							</div>
						</div>
						<div class="billing-vertical-spacer"></div>
						<v-select
							placeholder="qp Lima"
							class="filter-select-billing"
							selec></v-select>
					</div>
					<v-breadcrumbs
						divider="»"
						:class="{ 'housemaid-breadcrumb' : $route.name.split('-')[0] === 'housemaids' && $route.name !== 'housemaids-by-state' }">
						<v-breadcrumbs-item v-for="(item, itemIndex) in $breadcrumbsItems" :key="itemIndex"
							:to="item.href" :disabled="item.disabled" :active-class="'breadcrumbs__item--active'">
							<img
								v-if="firstItem(itemIndex)"
								:class="{ 'breadcrumb-company-icon' : item.href === '/company' }"
								:src="`${$imageS3}/clerkinn/breadcrumbs/${item.id}.${item.extension}`">
							<span class="ml-1">{{ item.text }}</span>
						</v-breadcrumbs-item>
					</v-breadcrumbs>
				</div>
				<hr
				class="billing-spacer"
				v-if="$route.path === '/billing/list'">
			</template>
			<v-container grid-list-md fluid>
				<router-view></router-view>
			</v-container>
		</main>
		<v-dialog v-model="dialog" width="300" content-class="modal-logout">
			<v-card>
				<v-card-text>¿Está seguro de que desea salir?</v-card-text>
				<v-card-actions>
					<v-btn class="btn-save mb-2 mr-2" @click.native="dialog = false">Cancelar</v-btn>
					<v-btn class="btn-cancel mb-2" @click.native="logout">Salir</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-app>
</template>

<script>
import { db } from '@/shared/firebase';
import helper from '@/shared/helper';
import mixin from '@/shared/mixins';
import { parseDate, round } from '@/shared/filters';
import bus from './../bus';

const helperData = helper.data();

function created() {
	this.helperMethods = helper.methods;
	const employee = this.helperMethods.getUser();
	this.companyId = employee.employeeCompany.data.id;
	this.loadData();
	this.loadNotifications();
}

function mounted() {
	const token = localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
	if (token) {
		window.addEventListener('click', (event) => {
			if (document.getElementById('notifications').contains(event.target)
			|| document.getElementById('buttonNotifications').contains(event.target)) {
				this.doNothing = true;
			} else {
				this.notificationsList = false;
			}
		});
	}
}

function deleteHousemaidAssignData() {
	if (this.$route.name !== 'housemaids-assign') {
		this.helperMethods.removeHousemaidAssign();
	}
}

function firstItem(index) {
	return index === 0;
}

async function loadData() {
	const user = this.helperMethods.getUser();
	const headers = {
		Accept: 'application/vnd.apiacl.v2+json',
	};
	this.localLanguage = localStorage.getItem(`${process.env.STORAGE_USER_KEY}::language`);
	if (!this.localLanguage) {
		localStorage.setItem(`${process.env.STORAGE_USER_KEY}::language`, 'es');
		this.localLanguage = localStorage.getItem(`${process.env.STORAGE_USER_KEY}::language`);
	}
	if (user) {
		this.user.fullName = this.buildUserFullName(user);
		this.user.url_image = '';
		const url = `${process.env.ACL_URL}/sidebar/${process.env.APP_CODE}`;
		const sidebarParams = {
			languages: this.localLanguage,
		};
		const { data: sidebar } = await this.$http.get(url, { params: sidebarParams, headers });
		this.sidebar = sidebar.data.map((menu) => {
			const newMenu = Object.assign({}, menu);
			newMenu.active = false;
			newMenu.resource.data.sort((a, b) => a.position - b.position);
			return newMenu;
		}).sort((a, b) => a.position - b.position);
	}
}

function buildUserFullName(user) {
	return `${user.name} ${user.lastname}`;
}

function loadNotifications() {
	this.$bindAsArray('notifications', db.ref(`Reservations/${this.companyId}`));
}

async function logout() {
	await this.$http.post(`${process.env.ACL_URL}/logout`);
	window.localStorage.clear();
	this.$router.push(this.loginHref);
}

function notificationsQuantity() {
	const self = this;
	this.newNotification = this.notifications.length > 0;
	setTimeout(() => {
		self.newNotification = false;
	}, 2000);
	return this.notifications.length;
}

function openNotifications() {
	this.notificationsList = !this.notificationsList;
}

function selectData({ code }) {
	this.$router.push({ name: 'calendar', params: { bookingCode: code } });
	this.notificationsList = false;
}

function setLanguage(lang) {
	localStorage.setItem(`${process.env.STORAGE_USER_KEY}::language`,
		lang);
	this.localLanguage = lang;
	this.loadData();
	bus.$emit('get-language', lang);
}

async function deleteNotification({ code }) {
	const url = `${process.env.PMS_URL}/booking/${code}/asignedroom`;
	await this.$http.delete(url);
	this.loadData();
}

export default {
	name: 'layout',
	computed: {
		deleteHousemaidAssignData,
		notificationsQuantity,
	},
	created,
	data() {
		return {
			companyId: 0,
			dialog: false,
			doNothing: false,
			drawer: true,
			helperMethods: null,
			languages: {
				es: {
					id: 'ES',
					img: helperData.flagEs,
					name: 'Español',
				},
				en: {
					id: 'EN',
					img: helperData.flagEn,
					name: 'English',
				},
			},
			localLanguage: '',
			loginHref: { name: 'login' },
			newNotification: false,
			notifications: [],
			notificationsList: false,
			sidebar: [],
			user: {
				fullName: '',
				url_image: '',
			},
		};
	},
	filters: {
		parseDate,
		round,
	},
	methods: {
		buildUserFullName,
		deleteNotification,
		firstItem,
		loadData,
		loadNotifications,
		logout,
		openNotifications,
		selectData,
		setLanguage,
	},
	mixins: mixin,
	mounted,
};
</script>

<style lang="scss" scoped>
.application {

	&--light .navigation-drawer {
		background-color: map-get($colors, header-dark);

		.toolbar {
			background-color: map-get($colors, default-skyblue);
		}

		.list,
		.sidebar-bg {
			background: map-get($colors, header-dark);
		}
	}
}

.list__tile__action {
	margin-right: 11.4px;
	min-width: auto;
}

.list.list--group .list__tile__action {
	margin-right: 16px;
	min-width: 19px;
}

.list--group__header {

	&:hover .list__tile .list__tile__title,
	&--active .list__tile .list__tile__title {
		a {
			color: white;
		}
	}
}

.navigation-drawer {
	width: 210px;

	&--persistent:not(.navigation-drawer--is-mobile).navigation-drawer--open:not(.navigation-drawer--right)~main,
	&--persistent:not(.navigation-drawer--is-mobile).navigation-drawer--open:not(.navigation-drawer--right):not(.navigation-drawer--clipped):not(.navigation-drawer--floating)~.toolbar-header {
		padding-left: 210px;
	}
}

.list--group__header>li:first-child {
	border-left: 7px solid transparent;

	&:hover {
		border-color: map-get($colors, menuselecteditem);
	}
}

.list--group__header--active>li:first-child {
	border-color: map-get($colors, menuselecteditem);
}

.toolbar-nav>div {
	height: 46px!important;
}

.toolbar-header .toolbar__side-icon {
	border-radius: 0;
	border-right: 1px solid #d8d8d8;
	height: 46px;
	margin-bottom: 0;
	margin-top: 0;
	padding-right: 7px;
}

.toolbar-header .toolbar__side-icon:hover {
	background-color: transparent;
}

.toolbar__title div {
	display: inline-block;
}

.user {

	h6 {
		color: map-get($colors, header-dark);
		font-size: map-get($sizes, thirdteen);
	}

	img {
		height: 30px;
		width: 30px;
	}

	&-name,
	&-img,
	.config {
		display: inline-flex;
	}

	&-name {
		margin-right: 6px;

		h6 {
			align-self: center;
			margin-bottom: 0;
		}
	}

	&-img img {
		align-self: center;
		border: 1px solid map-get($colors, default-bg);
		border-radius: 50px;
	}
}

.layout-nav {
	height: 46px;
}

.config:not(.sprite-menu):not(.sprite-breadcrumb) {
	margin: 0 16.8px;

	span {
		align-self: center;
	}
}

.login-button {
	background-color: map-get($colors, header-icons);
	color: white;
	height: 46px;
	margin-bottom: 0;
	padding: 0;
	width: 46px;

	.material-icons {
		color: white!important;
		font-size: 23px;
	}
}

.button-drawer {
	border-right: 1px solid map-get($colors, e-bg-icon);
	display: flex;
	height: 100%;
	padding: 0 8px;
}

.logo {
	margin: auto;
	max-height: 41px;
	position: absolute;
	right: 0;
	width: calc(100% - 210px);
	z-index: -1;

	img {
		max-height: 41px;
	}
}

.navigation-drawer--close {
	&+nav {
		.logo {
			width: 100%;
		}
	}
}

.modal-logout {
	.card {
		&__text {
			color: black;
			font-family: map-get($fonts, medium);
			font-size: map-get($sizes, twenty);
			padding-bottom: 30px;
		}

		&__actions {
			justify-content: center;
		}
	}
}

.billing-breadcrumb-style {
	align-items: center;
	background-color: map-get($colors, default-bg);
	display: flex;
	flex-flow: row-reverse;
	justify-content: space-between;
	padding: 5px 20px 0 0;
}

.billing-breadcrumb {
	display: grid;
	grid-gap: 16px;
	grid-template-columns: 1fr 1px 150px;
}

.billing-resume {
	display: grid;
	grid-template-columns: 1fr 1fr;
	text-align: right;
	p {
		margin: 0;
	}
}

.billing-resume-title {
	font-size: map-get($sizes, ten);
}

.billing-resume-content {
	color: map-get($colors, default-skyblue);
	font-size: map-get($sizes, fifteen);
	font-weight: bold;
}

.billing-spacer {
	border: 1px solid map-get($colors, e-bg-icon);
	margin-top: -1px;
}

.billing-vertical-spacer {
	border-right: 1px solid map-get($colors, e-bg-icon);
}

.notifications {
	&-btn {
		align-items: center;
		display: flex;
		margin-left: 21px;
		position: relative;

		p {
			background-color: white;
			border-radius: 100%;
			color: rgba(255, 255, 255, .9);
			font-family: map-get($fonts, bold);
			font-size: 9px;
			height: 16px;
			line-height: 16px;
			margin: 0px;
			position: absolute;
			right: -6px;
			text-align: center;
			top: -6px;
			transition: all 1s ease-in-out;
			width: 16px;

			span {
				background-color: map-get($colors, notification-number);
				border-radius: 100%;
				display: inline-block;
				height: 12px;
				line-height: 12px;
				width: 12px;
			}
		}
	}

	&-container {
		background-color: map-get($colors, notification-container);
		border: 2px solid map-get($colors, default-skyblue);
		border-radius: 15px;
		height: 330px;
		left: 231px;
		padding: 25px 19px 20px;
		position: absolute;
		top: 50px;
		width: 984px;

		label {
			color: map-get($colors, default-dark);
			font-family: map-get($fonts, medium);
			font-size: 13px;
		}

		&:after {
			border-bottom: 11px solid map-get($colors , notification-container);
			border-left: 10px solid transparent;
			border-right: 10px solid transparent;
			content: '';
			left: 48px;
			position: absolute;
			top: -11px;
		}

		&:before {
			border-bottom: 14px solid map-get($colors , default-skyblue);
			border-left: 13px solid transparent;
			border-right: 13px solid transparent;
			content: '';
			left: 45px;
			position: absolute;
			top: -14px;
		}
	}

	&-list {
		background-color: white;
		box-shadow: 0px 2px 6px 0px rgba($color: #000000, $alpha: .12);
		height: 245px;
		margin-top: 15px;
		overflow: auto;

		p {
			color: map-get($colors, clock-grey);
			font-family: map-get($fonts, medium);
			font-size: 14px;
			margin: 14px 0px;
		}

		&-border {
			border-bottom: 1px solid map-get($colors, border-radio);
			min-height: 47px;

			&:last-child {
				border-bottom: 0px;
			}
		}

		&-height {
			height: auto;
		}
	}

	&-assign-data {
		background-color: map-get($colors, default-skyblue);
		box-shadow: 0px 2px 4px 0px rgba($color: #000000, $alpha: .28);
		color: white;
		font-family: map-get($fonts, bold);
		font-size: 11px;
		height: 25px;
		width: 70px;
	}
}

.animated.bounceIn {
	animation-duration: .75s;
	-webkit-animation-duration: .75s;
}

@-webkit-keyframes bounceIn {
	from, 20%, 40%, 60%, 80%, to {
		-webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
		animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
	}

	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3);
	}

	20% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1);
	}

	40% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9);
	}

	60% {
		opacity: 1;
		-webkit-transform: scale3d(1.03, 1.03, 1.03);
		transform: scale3d(1.03, 1.03, 1.03);
	}

	80% {
		-webkit-transform: scale3d(.97, .97, .97);
		transform: scale3d(.97, .97, .97);
	}

	to {
		opacity: 1;
		-webkit-transform: scale3d(1, 1, 1);
		transform: scale3d(1, 1, 1);
	}
}

@keyframes bounceIn {
	from, 20%, 40%, 60%, 80%, to {
		-webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
		animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
	}

	0% {
		opacity: 0;
		-webkit-transform: scale3d(.3, .3, .3);
		transform: scale3d(.3, .3, .3);
	}

	20% {
		-webkit-transform: scale3d(1.1, 1.1, 1.1);
		transform: scale3d(1.1, 1.1, 1.1);
	}

	40% {
		-webkit-transform: scale3d(.9, .9, .9);
		transform: scale3d(.9, .9, .9);
	}

	60% {
		opacity: 1;
		-webkit-transform: scale3d(1.03, 1.03, 1.03);
		transform: scale3d(1.03, 1.03, 1.03);
	}

	80% {
		-webkit-transform: scale3d(.97, .97, .97);
		transform: scale3d(.97, .97, .97);
	}

	to {
		opacity: 1;
		-webkit-transform: scale3d(1, 1, 1);
		transform: scale3d(1, 1, 1);
	}
}

.bounceIn {
	-webkit-animation-name: bounceIn;
	animation-name: bounceIn;
}

.language-selected {
	outline: auto map-get($colors, default-skyblue);
}

.breadcrumb-company-icon {
	height: 22px;
}

.notifications-actions {
	height: 30px;
	margin-left: 5px;
	width: 30px !important;
}

.reservation {
	background-color: map-get($colors, booking) !important;
}
</style>



// WEBPACK FOOTER //
// Layout.vue?42a9649d